export default {
  Nenhum: 0,
  VamosFechar: 1,
  ProblemasComVeiculos: 2,
  ForaDeArea: 3,
  AreaDeRisco: 4,
  Outro: 5,
  ClienteSolicitouCancelamento: 6,
  PedidoFoiTrote: 7,
  TelefoneClienteInvalido: 8,
  EnderecoClienteInvalido: 9,
  CanceladoPorTempoExcedido: 10,
  BeneficioGasDoPovoIndisponivel: 11
}
